function getSearchParam(name: string): string | null {
    return new URLSearchParams(document.location.search).get(name);
}

export function getSelectedWarehouseId(): number | undefined {
    const warehouseParam = getSearchParam('warehouse');
    return warehouseParam ? parseInt(warehouseParam, 10) : undefined;
}

export function isTransportOrderCreationFormV2Enabled(): boolean {
    return getSearchParam('transportOrderCreationFormV2') === 'true';
}
